import { useDispatch, useSelector } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { fetchLikes, fetchUnlikes } from "../../features/video/videoSlice";

export default function LikeUnlike() {
  const { video } = useSelector((state) => state.video);
  const dispatch = useDispatch();

  const { id, likes, unlikes } = video || {};

  return (
    <div className="flex gap-10 w-48">
      <div
        className="flex gap-1 cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          dispatch(fetchLikes(id));
        }}
      >
        <div className="shrink-0">
          <img className="w-5 block" src={likeImage} alt="Like" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {likes}
        </div>
      </div>
      <div
        className="flex gap-1 cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          dispatch(fetchUnlikes(id));
        }}
      >
        <div className="shrink-0">
          <img className="w-5 block" src={unlikeImage} alt="Unlike" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {unlikes}
        </div>
      </div>
    </div>
  );
}
